import { Box, Stack, Typography, List, ListItem } from '@mui/material';
import {
	containerNextSX,
	containerTitleNextSX,
	listItemSX,
	subtitleSX,
	titleSX,
} from '@/components/blocks/DpLibrary/DpNextBenefit/style/main';
import { DpRewardsCrown } from '@/components/content/Account/parts/DpRewardsCrown';

export const DpNextBenefit = ({
	title,
	subtitle1,
	subtitle2,
	subtitle3,
}: {
	title: string;
	subtitle1: string;
	subtitle2: string;
	subtitle3: string;
}) => {
	const subtitles = [subtitle1, subtitle2, subtitle3].filter(Boolean);

	return (
		<Stack sx={containerNextSX}>
			<Stack>
				<Box sx={containerTitleNextSX}>
					<DpRewardsCrown fill={'#ED2859'} background={'#E8E8E8'} />
					{title ? (
						<Typography component="h2" sx={titleSX}>
							{' '}
							{title}{' '}
						</Typography>
					) : null}
				</Box>
				{subtitles.length > 0 ? (
					<List sx={subtitleSX}>
						{subtitles.map((subtitle, index) => (
							<ListItem key={index} sx={listItemSX}>
								{subtitle}
							</ListItem>
						))}
					</List>
				) : null}
			</Stack>
		</Stack>
	);
};
